import React from 'react';
import localStorage from '../../Common/LocalStorage';

import DatePicker, { registerLocale } from 'react-datepicker';
import { enGB, de, fr, it } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

registerLocale('en', enGB);
registerLocale('de', de);
registerLocale('fr', fr);
registerLocale('it', it);

export const CustomDatePicker = props => {

    let formatedDate = props.selectedDate ? new Date(moment(props.selectedDate, 'DD/MM/YYYY')) : null;
  
    return (
        <div className={props.extraClass}>
            <label>{props.lable}</label>
            <DatePicker
                locale={localStorage.getFromStorage('lang')}
                selected={formatedDate}
                dateFormat='dd/MM/yyyy'
                placeholderText={props.placeholder}
                onSelect={props.getDateHandler}
                showMonthDropdown
                showYearDropdown
                scrollableYearDropdown
                yearDropdownItemNumber={50}
            />
        </div>
    )
};



// WEBPACK FOOTER //
// ./src/customModules/Patients/components/CustomDatePicker.js